import { useState, useEffect, useRef } from "react";

import { api } from "./pureFunctions"
import "./styles/karte.css";
import axios from "axios";

const api_key = import.meta.env.VITE_OPENWEATHER_API??"";

export default function GetGeoCoords({ searchCoords, setSearchCoords }) {
   const [searchOrt, setSearchOrt] = useState("");

   async function getCoords(ort) {
      let url;
      const isNotPlz = isNaN(ort);
      if (isNotPlz) {
         url = `https://api.openweathermap.org/geo/1.0/direct?q=${ort},DE&limit=5&appid=` + api_key;
      } else {
         url = `https://api.openweathermap.org/geo/1.0/zip?zip=${ort},DE&appid=` + api_key;
      }
      console.log(url);

      /* {API key} */
      
      await axios
         .get(url)
         .then((data) => {
            console.log(data);
            if (isNotPlz) {
               if (data.data.length) setSearchCoords(data.data[0]);
            } else {
               setSearchCoords(data.data);
            }
         })
         .catch((err) => {
            console.log(err);
         });
   }
   return (
      <div className="flex-row" style={{
               borderRadius: "8px",
               margin: "20px",
               boxShadow: "0 0 20px #000",
               position: "absolute",
               zIndex: 100
            }}>
         <input
            type="text"
            value={searchOrt}
            placeholder="PLZ oder Ort"
            onChange={(e) => setSearchOrt(e.target.value)}
            style={{
               borderRadius: "8px 0 0 8px",
               marginRight: "0",
               paddingLeft: 8,
               width: "400px",
               height: "36px",
               border: "none",
               backgroundColor: "#fff",
               color: "#000",
            }}
         />
         <button
            style={{
               borderRadius: "0 8px 8px 0",
               marginRight: "0",
               width: "40px",
               height: "36px",
               border: "none",
               backgroundColor: "#224",
               color: "#fff",
            }}
            variant="success"
            onClick={() => getCoords(searchOrt)}
         >
            →
         </button>
      </div>
   );
}
